<template>
	<v-app :style="cssColors" class="app-class">
		<v-container v-if="carregandoDadosFixos || carregandoUsuario || usuarioLogado === null" class="fill-height">
			<v-row align="center" justify="center">
				<v-col cols="auto">
					<v-progress-circular indeterminate color="primary"/>
				</v-col>
				<v-col cols="auto">
					<h3 class="primary--text">Iniciando...</h3>
				</v-col>
			</v-row>
		</v-container>
		<template v-else>
			<SystemMenu />
			<v-main style="position:relative; padding-top: 0px;">
				<router-view :key="route.path" />
			</v-main>
		</template>
	</v-app>
</template>

<script setup>
import { vuetify } from '@/plugins/vuetify'
import SystemMenu from "@/components/navegacao/SystemMenu.vue";
import * as dadosFixosService from "@/services/DadosFixosService.js";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from '@/store';

const route = useRoute();
const router = useRouter();

const carregandoDadosFixos = computed(() => store.getters["dadosFixos/getCarregando"]);
const carregandoUsuario = computed(() => store.getters["usuario/getCarregandoUsuario"]);
const usuarioLogado = computed(() => store.getters["usuario/getUsuarioLogado"]);

const cssColors = computed(() => {
	const cssColors = {};
	Object.entries(vuetify.theme.current.value.colors).forEach((item) => {
		if (item.length === 2) {
			cssColors[`--${item[0]}`] = item[1];
		}
	});
	return cssColors;
});

const rotaAutenticada = computed(() => {
	return route.meta == null || route.meta.isAuthenticated == null || route.meta.isAuthenticated == true;
});

async function carregarDadosUsuario() {
	if (!usuarioLogado.value && rotaAutenticada.value) {
		dadosFixosService.carregarDadosFixosUsuarioLogado(store, router);
	}
}

onMounted(async () => {
	await carregarDadosUsuario();
	dadosFixosService.carregarDadosFixosUsuarioNaoLogado(store, router);
});
</script>

<style lang="css" scoped>
.row-pointer:deep(tbody tr :hover) {
  cursor: pointer;
}

*:deep(.v-data-table table) {
  border-radius: 6px;
  overflow: hidden;
}

*:deep(.v-data-table thead tr) {
  background-color: var(--backgroundCardDark)
}

*:deep(.v-data-table thead tr th span) {
  text-transform: uppercase;
  font-weight: bolder;
}

*:deep(.v-data-table tbody tr td) {
  height: 52px !important;
}

*:deep(.v-data-table .v-data-table-header tr th) {
  height: 36px !important;
}

*:deep(.v-data-table tr td), *:deep(.v-data-table tr th) {
  border: none !important;
}

*:deep(.v-data-table tbody tr:nth-child(odd)) {
	background-color: var(--filled)
}

*:deep(.v-data-table tbody tr:nth-child(even)) {
	background-color: var(--secondary)
}

*:deep(.v-pagination__item.v-pagination__item) {
  box-shadow: none;
	border: 1px solid var(--paginationColor);
	color: var(--paginationColor);
}

*:deep(.v-pagination__item.v-pagination__item--active) {
	color: white;
}

*:deep(.v-pagination__navigation) {
	border: 1px solid var(--paginationColor);
  	box-shadow: none;
}

* {
	-webkit-print-color-adjust: exact !important; /* Chrome, Safari, Edge */
}

*:deep(.v-menu__content) {
	max-width: min(80%, 900px);
}

.app-class{
	background-color: var(--background);
	font-family: 'Roboto', Arial, Helvetica, sans-serif;
	font-weight: 500;
	font-smooth: auto;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-rendering: optimizeLegibility;
	text-shadow: rgba(0,0,0,.01) 0 0 1px;
}

</style>
